import { ReactNode } from "react"
import { FormattedMessage } from "react-intl"

import ErrorModal from "./ErrorModal"

interface Props {
  closeModal: () => void
  children?: ReactNode
}

const DeleteMessageErrorModal = ({ closeModal }: Props) => {
  return (
    <ErrorModal closeModal={closeModal} showHeading={false}>
      <FormattedMessage
        id="chat.deleteErrorMessage"
        defaultMessage="Unable to delete message at this time. Please reload the page and try again."
      />
    </ErrorModal>
  )
}

export default DeleteMessageErrorModal
